import React from 'react';

/**
 * Appkit 4 "minimize-outline" icon, inlined as a React component so it can be
 * recolored via `currentColor` and styled with CSS.
 *
 * Source: Appkit4 icon set (Icon/Outline/minimize-outline). The original
 * `fill="#474747"` has been replaced with `currentColor`.
 *
 * @param {React.SVGProps<SVGSVGElement>} props
 */
export default function MinimizeOutlineIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      role="img"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <g fill="currentColor" fillRule="nonzero">
        <path d="M7.5,0 L9,0 L9,9 L0,9 L0,7.5 L7.5,7.5 L7.5,0 Z M15.0000001,0 L16.5000001,0 L16.5000001,7.5 L24.0000001,7.5 L24.0000001,9 L15.0000001,9 L15.0000001,0 Z M15.0000001,15.0000001 L24.0000001,15.0000001 L24.0000001,16.5000001 L16.5000001,16.5000001 L16.5000001,24.0000001 L15.0000001,24.0000001 L15.0000001,15.0000001 Z M0,15.0000001 L9,15.0000001 L9,24.0000001 L7.5,24.0000001 L7.5,16.5000001 L0,16.5000001 L0,15.0000001 Z" />
      </g>
    </svg>
  );
}
